<template>
  <div>
    <h1>404</h1>
    <p>你是迷路了吗</p>
  </div>
</template>

<script>
  export default {
    name: 'Err404',
    components: {},
    props: {},
    data() {
      return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
    watch: {}
  };
</script>

<style scoped></style>
